import { FC, useEffect, useState } from 'react';
import { SCUIButton, SCUILoadingLinear, SCUITabs } from '../../atomic/atoms';
import { RuleServiceCommand } from '../../services/command/';
import Popover from '@mui/material/Popover';
import {
    Grid,
    IconButton,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Chip,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Stack,
} from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUISnackbar } from '../../atomic/molecules';
import { RuleTabEnum } from './enum/RuleTab.enum';
import AddIcon from '@mui/icons-material/Add';
import { SCUIRuleTemplateModal } from './components/modals/SCUIRuleTemplateModal';
import { SCUIRuleModal } from './components/modals/SCUIRuleModal';
import { SCUICriteriaTypeModal } from './components/modals/SCUICriteriaTypeModal';
import { getSnackbarActionMessage } from './helper/RuleModal.helper';
import { getTenants } from './helper/RuleModal.mapper';
import { Operators, RuleTenant, TableColumns, Tabs, TabsDict } from './RuleService.const';
import { enumSnackbarStatusType } from '../../types/enums';
import PopupState, { bindTrigger, bindMenu, bindPopover } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RuleServiceQuery from '../../services/query/ruleService/RuleServiceQuery.services';
import Pagination from '@mui/material/Pagination';
import Swal from 'sweetalert2';

const regionId = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId?.toString();

export const RuleService: FC<any> = () => {
    const { t } = useTranslation();

    const tenants = getTenants();

    const [tenant, setTenant] = useState(0);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        show: false,
        message: '',
        status: enumSnackbarStatusType.success,
    });

    const takeCount = 20;
    const [allRowCount, setAllRowCount] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<any>({ page: 1 });
    const [tabIndex, setTabIndex] = useState<RuleTabEnum>(0);
    const [tableHeader, setTableHeader] = useState<string[]>([]);

    const [ruleModalOpen, setRuleModalOpen] = useState(false);
    const [ruleTemplateModalOpen, setRuleTemplateModalOpen] = useState(false);
    const [criteriaTypeModalOpen, setCriteriaTypeModalOpen] = useState(false);

    const [criteriaTypes, setCriteriaTypes] = useState([]);
    const [rules, setRules] = useState([]);
    const [ruleTemplates, setRuleTemplates] = useState([]);

    const [currentRule, setCurrentRule] = useState({});

    const _onChangeTabs = (_: any, activeTabIndex: any): void => {
        setTabIndex(activeTabIndex);
    };
    const deleteRule = async (id: number) => {
        try {
            await RuleServiceQuery.DeleteRule(id);
            setSnackbar({
                show: true,
                message: t('ruleManagement.notify.rule.deleteNewRuleSuccess'),
                status: enumSnackbarStatusType.success,
            });
            await getPayLoad();
        } catch {
            setSnackbar({
                show: true,
                message: t('ruleManagement.notify.rule.deleteNewRuleFailed'),
                status: enumSnackbarStatusType.danger,
            });
        }
    };

    const confirmDeleteRule = async (id: number) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinizden emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.yes'),
            cancelButtonText: t('general.no'),
        });

        if (result.isConfirmed) {
            await deleteRule(id);
        }
    };
    const handlePageChange = async (_: any, newPage: any) => {
        setCurrentPage({ page: newPage });
    };
    useEffect(() => {
        const fetchData = async () => {
            await getPayLoad();
        };
        fetchData();
    }, [currentPage]);
    useEffect(() => {
        let newColumn = TableColumns(tabIndex);
        setCurrentPage({ page: 1 });
        setTableHeader(newColumn);
    }, [tabIndex]);

    const getDate = (date: any) => {
        return new Date(date).toLocaleDateString('tr-TR');
    };
    useEffect(() => {
        const fetchData = async () => {
            await getPayLoad();
        };
        fetchData();
    }, [tenant]);
    const getPayLoad = async () => {
        setLoading(true);
        let currentTab = Tabs(tabIndex);
        console.log(currentTab, 'currentTab');
        console.log(takeCount);
        console.log(currentPage);

        console.log(currentPage.page);

        try {
            if (currentTab?.id == RuleTabEnum.CriteriaType) {
                let response = await RuleServiceCommand.GetCriteriaTypeList({
                    Tenant: tenant,
                    Take: takeCount,
                    Skip: takeCount * (currentPage.page - 1),
                });
                setCriteriaTypes(response.data);
                setAllRowCount(response.totalPages);
            }
            if (currentTab?.id == RuleTabEnum.RuleTemplate) {
                let criteriaTypes = await RuleServiceCommand.GetCriteriaTypeList({
                    Tenant: tenant,
                    Skip: 0,
                });
                setCriteriaTypes(criteriaTypes.data);
                let ruleTemplates = await RuleServiceCommand.GetRuleTemplateList({
                    Tenant: tenant,
                    Take: takeCount,
                    Skip: takeCount * (currentPage.page - 1),
                });
                setRuleTemplates(ruleTemplates.data);
                setAllRowCount(ruleTemplates.totalPages);
            }
            if (currentTab?.id == RuleTabEnum.Rule) {
                let rules = await RuleServiceCommand.GetRuleList({
                    Tenant: tenant,
                    Status: 1,
                    RegionId: regionId,
                    Take: takeCount,
                    Skip: currentPage.page - 1,
                });
                let ruleTemplates = await RuleServiceCommand.GetRuleTemplateList({
                    Tenant: tenant,
                    Skip: 0,
                });
                setAllRowCount(rules.totalPages);
                setRuleTemplates(ruleTemplates.data);
                setRules(rules.data);
            }

            let message = getSnackbarActionMessage(tabIndex, enumSnackbarStatusType.success, 'get');
            setSnackbar({
                show: true,
                message: message,
                status: enumSnackbarStatusType.success,
            });
        } catch {
            setLoading(false);
            let message = getSnackbarActionMessage(tabIndex, enumSnackbarStatusType.danger, 'get');
            setSnackbar({
                show: true,
                message: message,
                status: enumSnackbarStatusType.danger,
            });
        }

        setLoading(false);
    };
    return (
        <SCUIContent>
            <div
                style={{
                    display: 'flex',
                    position: 'absolute',
                    right: '32px',
                    flexDirection: 'column',
                    zIndex: 500,
                }}
            >
                <InputLabel id={'Tenant'}> Tenant</InputLabel>
                <Select
                    sx={{ minWidth: '140px' }}
                    id="Tenant"
                    onChange={async (event: any) => {
                        setTenant(parseInt(event.target.value));
                    }}
                    value={tenant}
                    size="medium"
                >
                    {tenants &&
                        tenants.map((item: any, index: number) => (
                            <MenuItem key={index} id={item.label} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                </Select>
            </div>
            <Grid
                size={{
                    sm: 5,
                    md: 5,
                    lg: 5,
                    xl: 5,
                }}
            >
                <Grid container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }}>
                    <SCUIBreadCrumb
                        title={t('ruleManagement.breadcrumb')}
                        componentLink={'/rule-management'}
                        style={{ cursor: 'pointer' }}
                    />
                    <SCUITabs tabList={TabsDict()} onChange={_onChangeTabs} activeTabIndex={tabIndex}></SCUITabs>

                    <Grid sx={{ margin: '2rem', minWidth: 150 }}>
                        {tabIndex == RuleTabEnum.CriteriaType && (
                            <SCUIButton
                                showStartIcon
                                startIcon={<AddIcon style={{ color: 'white' }} />}
                                text={t('ruleManagement.createNewCriteriaType')}
                                type="primary"
                                fullwidth
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => {
                                    setCriteriaTypeModalOpen(true);
                                }}
                            />
                        )}
                        {tabIndex == RuleTabEnum.Rule && (
                            <SCUIButton
                                showStartIcon
                                startIcon={<AddIcon style={{ color: 'white' }} />}
                                text={t('ruleManagement.createNewRule')}
                                type="primary"
                                fullwidth
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => {
                                    setRuleModalOpen(true);
                                }}
                            />
                        )}
                        {tabIndex == RuleTabEnum.RuleTemplate && (
                            <SCUIButton
                                showStartIcon
                                startIcon={<AddIcon style={{ color: 'white' }} />}
                                text={t('ruleManagement.createNewRuleTemplate')}
                                fullwidth
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => {
                                    setRuleTemplateModalOpen(true);
                                }}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <SCUILoadingLinear display={loading} />
            <TableContainer>
                <Table component={Paper} style={{ marginBottom: '2rem' }}>
                    <TableHead>
                        <TableRow>
                            {tableHeader &&
                                tableHeader.map((header: any, index: number) => (
                                    <TableCell key={index} style={{ textAlign: 'center', minWidth: 250 }}>
                                        {header}
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    {!loading && (
                        <TableBody>
                            {tabIndex === RuleTabEnum.CriteriaType &&
                                criteriaTypes?.length &&
                                criteriaTypes.map((type: any, key: number) => {
                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ textAlign: 'center' }}>{type.id}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{type.name}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{type.key}</TableCell>
                                            <TableCell
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Chip
                                                    label={type.criteriaTypeValues.length > 0 ? 'True' : 'False'}
                                                    color={type.criteriaTypeValues.length > 0 ? 'success' : 'warning'}
                                                />
                                                {type.criteriaTypeValues.length > 0 && (
                                                    <PopupState variant="popover" popupId="demo-popup-popover">
                                                        {(popupState) => (
                                                            <div>
                                                                <Chip
                                                                    label={
                                                                        type.criteriaTypeValues.length == 1
                                                                            ? 1
                                                                            : '+' + type.criteriaTypeValues.length
                                                                    }
                                                                    {...bindTrigger(popupState)}
                                                                />
                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'center',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'center',
                                                                    }}
                                                                >
                                                                    <Table
                                                                        component={Paper}
                                                                        style={{ marginBottom: '2rem' }}
                                                                    >
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.criteriaType.child.name'
                                                                                    )}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.criteriaType.child.value'
                                                                                    )}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {type.criteriaTypeValues.map(
                                                                                (item: any, index: number) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {item.name}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {item.value}
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                            )}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Popover>
                                                            </div>
                                                        )}
                                                    </PopupState>
                                                )}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {RuleTenant[type.tenant as keyof typeof RuleTenant]}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {tabIndex === RuleTabEnum.Rule &&
                                rules?.length &&
                                rules.map((type: any, key: number) => {
                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ textAlign: 'center' }}>{type.id}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{type.ruleKey}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {getDate(type.effectiveDate)}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {getDate(type.endDate)}
                                            </TableCell>

                                            <TableCell
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Chip
                                                    label={type.criteria.length > 0 ? 'True' : 'False'}
                                                    color={type.criteria.length > 0 ? 'success' : 'warning'}
                                                />
                                                {type.criteria.length > 0 && (
                                                    <PopupState variant="popover" popupId="demo-popup-popover">
                                                        {(popupState) => (
                                                            <div>
                                                                <Chip
                                                                    label={
                                                                        type.criteria.length == 1
                                                                            ? 1
                                                                            : '+' + type.criteria.length
                                                                    }
                                                                    {...bindTrigger(popupState)}
                                                                />
                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'center',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'center',
                                                                    }}
                                                                >
                                                                    <Table
                                                                        component={Paper}
                                                                        style={{ marginBottom: '2rem' }}
                                                                    >
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.criteriaType.key.name'
                                                                                    )}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.ruleTemplate.operator.name'
                                                                                    )}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {type.criteria.map(
                                                                                (item: any, index: number) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {item.key}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                Operators()[
                                                                                                    item.operator
                                                                                                ].label
                                                                                            }
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                            )}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Popover>
                                                            </div>
                                                        )}
                                                    </PopupState>
                                                )}
                                            </TableCell>

                                            <TableCell style={{ textAlign: 'center' }}>
                                                {' '}
                                                <PopupState variant="popover" popupId="demo-popup-menu">
                                                    {(popupState: any) => (
                                                        <>
                                                            <IconButton {...bindTrigger(popupState)}>
                                                                <MoreVertIcon className="svg_icons" />
                                                            </IconButton>
                                                            <Menu {...bindMenu(popupState)}>
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        setCurrentRule(type);
                                                                        setRuleModalOpen(true);
                                                                    }}
                                                                >
                                                                    {t('general.edit')}
                                                                </MenuItem>
                                                                <MenuItem onClick={() => confirmDeleteRule(type.id)}>
                                                                    {t('general.delete')}
                                                                </MenuItem>
                                                            </Menu>
                                                        </>
                                                    )}
                                                </PopupState>{' '}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {tabIndex === RuleTabEnum.RuleTemplate &&
                                ruleTemplates?.length &&
                                ruleTemplates.map((type: any, key: number) => {
                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ textAlign: 'center' }}>{type.id}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{type.name}</TableCell>
                                            <TableCell
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Chip
                                                    label={type.criteriaTypes.length > 0 ? 'True' : 'False'}
                                                    color={type.criteriaTypes.length > 0 ? 'success' : 'warning'}
                                                />
                                                {type.criteriaTypes.length > 0 && (
                                                    <PopupState variant="popover" popupId="demo-popup-popover">
                                                        {(popupState) => (
                                                            <div>
                                                                <Chip
                                                                    label={
                                                                        type.criteriaTypes.length == 1
                                                                            ? 1
                                                                            : '+' + type.criteriaTypes.length
                                                                    }
                                                                    {...bindTrigger(popupState)}
                                                                />
                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'center',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'center',
                                                                    }}
                                                                >
                                                                    <Table
                                                                        component={Paper}
                                                                        style={{ marginBottom: '2rem' }}
                                                                    >
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.criteriaType.name.name'
                                                                                    )}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    {t(
                                                                                        'ruleManagement.fields.ruleTemplate.operator.name'
                                                                                    )}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {type.criteriaTypes.map(
                                                                                (item: any, index: number) => (
                                                                                    <TableRow key={index}>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {item.name}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                textAlign: 'center',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                Operators()[
                                                                                                    item.operator
                                                                                                ].label
                                                                                            }
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                            )}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Popover>
                                                            </div>
                                                        )}
                                                    </PopupState>
                                                )}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {RuleTenant[type.tenant as keyof typeof RuleTenant]}
                                            </TableCell>
                                            {/*<TableCell*/}
                                            {/*    style={{justifyContent: "space-evenly", alignItems: "center", display: "flex"}}>*/}
                                            {/*    <SCUIButton text={"Güncelle"} type="primary" sizeType="fixed" size={"s"}*/}
                                            {/*                onClick={() => {*/}
                                            {/*                    openModal(type)*/}
                                            {/*                }}/>*/}
                                            {/*    <SCUIButton text={"Sil"} type="secondary" sizeType="fixed" size={"s"}*/}
                                            {/*                onClick={() => {*/}
                                            {/*                }}/>*/}
                                            {/*</TableCell>*/}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    )}
                </Table>
                <Grid>
                    <Stack spacing={2} style={{ alignItems: 'end' }}>
                        <Pagination
                            count={allRowCount}
                            color="primary"
                            page={currentPage.page}
                            onChange={handlePageChange}
                        />
                    </Stack>
                </Grid>
            </TableContainer>
            <SCUISnackbar
                show={snackbar.show}
                messageText={snackbar.message}
                status={snackbar.status}
                autoHideDuration={2000}
                onClose={() => {
                    setSnackbar({
                        show: false,
                        message: '',
                        status: enumSnackbarStatusType.success,
                    });
                }}
            />
            <>
                {ruleTemplateModalOpen && (
                    <SCUIRuleTemplateModal
                        open={ruleTemplateModalOpen}
                        criteriaTypes={criteriaTypes}
                        tenant={tenant}
                        onClose={(snackBarSettings: any) => {
                            setRuleTemplateModalOpen(false);
                            setSnackbar({
                                show: snackBarSettings.show,
                                message: snackBarSettings.message,
                                status: snackBarSettings.status,
                            });
                            if (snackBarSettings.status != enumSnackbarStatusType.danger) getPayLoad();
                        }}
                    ></SCUIRuleTemplateModal>
                )}
                {criteriaTypeModalOpen && (
                    <SCUICriteriaTypeModal
                        open={criteriaTypeModalOpen}
                        onClose={(snackBarSettings: any) => {
                            setCriteriaTypeModalOpen(false);
                            setSnackbar({
                                show: snackBarSettings.show,
                                message: snackBarSettings.message,
                                status: snackBarSettings.status,
                            });
                            if (snackBarSettings.status != enumSnackbarStatusType.danger) getPayLoad();
                        }}
                        tenant={tenant}
                    />
                )}
                {ruleModalOpen && (
                    <SCUIRuleModal
                        open={ruleModalOpen}
                        onClose={(snackBarSettings: any) => {
                            setRuleModalOpen(false);
                            setCurrentRule({
                                id: 0,
                                ruleTemplateId: 0,
                                ruleKey: '',
                                regionId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId,
                                action: '',
                                priority: '' as string | number,
                                Tenant: tenant,
                                criteria: [] as any,
                            });
                            setSnackbar({
                                show: snackBarSettings.show,
                                message: snackBarSettings.message,
                                status: snackBarSettings.status,
                            });
                            if (snackBarSettings.status != enumSnackbarStatusType.danger) getPayLoad();
                        }}
                        currentRule={currentRule}
                        ruleTemplates={ruleTemplates}
                        tenant={tenant}
                    />
                )}
            </>
        </SCUIContent>
    );
};
